import { FreeQrCodeGeneratorPage } from '../components/pages/FreeQrCodeGeneratorPage/FreeQrCodeGeneratorPage'
import { getFreeQrCodeGeneratorPageServerSideProps } from '../components/pages/FreeQrCodeGeneratorPage/getFreeQrCodeGeneratorPageServerSideProps'

export const getServerSideProps = getFreeQrCodeGeneratorPageServerSideProps

export default FreeQrCodeGeneratorPage
